// locale for Poetry

import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';

export default safeLoadLocale('poetry_locale');
